import router from '@/router'

export default {
  namespaced: true,
  state: {
    isLoaded: false,
    maintenance_incoming_message: null
  },
  mutations: {
    isLoaded(state, isLoaded) {
      state.isLoaded = isLoaded
    },
    maintenance_incoming_message(state, maintenance_incoming_message) {
      state.maintenance_incoming_message = maintenance_incoming_message
    },
  },
  getters: {
    isLoaded: state => state.isLoaded,
    maintenanceIncomingMessage: state => state.maintenance_incoming_message
  },
  actions: {
    isLoaded({
      commit
    }, isLoaded) {
      commit('isLoaded', isLoaded)
    },
    setMaintenanceIncomingMessage({
      commit
    }, maintenance_incoming_message) {
      commit('maintenance_incoming_message', maintenance_incoming_message)
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/app.js